package com.arena_web.ui.utils

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import kotlin.js.Date

fun Modifier.flexContainer(): Modifier {
    return this
        .fillMaxWidth()
        .styleModifier {
            property("flex", "1")
            property("height", "100%")
            property("min-width", "0")
            property("width", "100%")
            property("overflow", "hidden")
        }
}

fun Modifier.flexContainer(flexValue: String): Modifier {
    return this
        .fillMaxWidth()
        .styleModifier {
            property("flex", flexValue)
            property("height", "100%")
            property("min-width", "0")
            property("width", "100%")
            property("overflow", "hidden")
        }
}

fun Modifier.flexContent(): Modifier {
    return this.styleModifier {
        property("flex", "1")
        property("min-height", "0")
    }
}

fun formatDateTime(iso: String): String {
    return try {
        val d = Date(iso)
        val day = d.getDate().toString().padStart(2, '0')
        val month = arrayOf(
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        )[d.getMonth()]
        val year = d.getFullYear()
        val hours = d.getHours().toString().padStart(2, '0')
        val minutes = d.getMinutes().toString().padStart(2, '0')
        "$day $month $year, $hours:$minutes"
    } catch (_: Exception) {
        iso
    }
}
